import React from "react";
import Card from "./Layout/Card";

const Checkfront = ({checkfont_subevent,checkfront_name,checkfront_sub_total}) => {
  const bookingURL = 'https://fpronline.checkfront.com/reserve/?item_id='+checkfont_subevent

  return (
    <React.Fragment>
      <Card backgroundcolor="#000000" color="#52c2f0">                
      </Card>
      <Card backgroundcolor="#FCC02E" color="#000">
        <p>{checkfront_name}</p>
        <p><a href={bookingURL} style={{textDecoration: 'underline', color: '#000'}} target="_blank" rel="noreferrer">Check offer for {checkfront_sub_total}</a></p>
      </Card>
    </React.Fragment>
  );
};

export default Checkfront;
